import { Injectable } from "@angular/core";
import { UserService } from "@app/services/user.service";

@Injectable()
export class AuthenticationService {
  constructor(private userService: UserService) {}

  public login(email: string, password: string) {
    this.userService.authenticate(email, password).then((user) => {
      if (user && user.token) {
        localStorage.setItem("currentUser", JSON.stringify(user));
      }
    });
  }

  public isValid(): boolean {
    return localStorage.getItem("currentUser") != null;
  }

  public logout() {
    localStorage.removeItem("currentUser");
  }
}
